import { render, staticRenderFns } from "./StaffDetailPage.vue?vue&type=template&id=4936e7ac&"
import script from "./StaffDetailPage.vue?vue&type=script&lang=ts&"
export * from "./StaffDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports